import React from 'react';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import MixedMedia from '../mixedMedia/mixedMedia';
import OrderModule from '../orderModule/orderModule';
import styles from './flexibleSetPage.scss';
import ProductInfoShutter from '../productInfoShutter/productInfoShutter';
import { loadMediaOverlay } from '../lazyComponents';
import VariantPanel from '../variantPanel/variantPanel';
import { IInjectedProps } from '../../types';
import ErrorBoundary from '../../helpers/errorBoundary';
import StickyHeader from '../stickyHeader/stickyHeader';
import ArticleNumber from '../orderModule/articleNumber/articleNumber';
import ArticlePrice from '../orderModule/articlePrice/articlePrice';
import BasketPanel from '../orderModule/basketPanel/basketPanel';
import IconArrowExtraSmallRight from '../icons/icon_arrow_extra_small_right';
import * as helper from '../../helpers/html-helper';
import '../../styles/customTabNavigationStyles.scss';
import ShutterModul from '../shutterModul/shutterModul';
import LayoutedContentGrid from '../layoutedContentGrid/layoutedContentGrid';
import FragmentPlaceholder from '../fragmentPlaceholder/fragmentPlaceholder';

const MediaOverlay = React.lazy(loadMediaOverlay);
const DebugBar = React.lazy(() => import(/* webpackChunkName: 'debug-bar' */ '../debugBar/debugBar'));

const FlexibleSetPage = inject('store')(
    observer(({ store }: IInjectedProps) => {
        if (!store)
            return null;

        const { variantButtonCount } = store.variantStore;
        const [isClient, setIsClient] = React.useState(false);

        const initialLayoutedContentGridState = store?.fetchedData.shutterModule.layoutedContentGridKeys &&
            store.fetchedData.shutterModule.layoutedContentGridKeys.length > 0;
        const [hasLayoutedContentGrid, setLayoutedContentGridState] =
            React.useState(initialLayoutedContentGridState);

        const updateLayoutedContentGridState = (isAvailable: boolean) => {
            setLayoutedContentGridState(isAvailable);
        }

        const mixMediaRef = React.createRef<HTMLDivElement>();
        const floatRef = React.createRef<HTMLDivElement>();
        const orderModuleRef = React.createRef<HTMLDivElement>();

        React.useEffect(() => {
            setIsClient(true);
            if (orderModuleRef.current) {
                store.setOrderModuleRef(orderModuleRef.current);
            }
        }, []);

        function scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
        return (
            <div className={classNames(styles.flexibleSetPage,
                store?.variantStore?.isVariantSelectionPanelOpen ? styles.vs_is_open : '',
                store?.variantStore?.isVariantPanelOpen ? styles.vp_is_open : ''
            )}>
                <div className={styles.hidden_fragment}>
                    <FragmentPlaceholder src={'/layoutedcontentgrid-rmu/layoutedcontentgrid-fragment/assets'}
                        ignoreErrors={true} timeout={2} />
                </div>
                <div className={styles.overlay_modal_background}></div>
                <div className={styles.flexibleSetPage_top_container}>
                    {!store.dataStore.contextData.isRelease && isClient &&
                        <React.Suspense fallback={null}>
                            <DebugBar />
                        </React.Suspense>}
                    {store.mixedMediaStore.displayMediaOverlay &&
                        <React.Suspense fallback={null}>
                            <MediaOverlay />
                        </React.Suspense>}
                    <ErrorBoundary fallback={<p>Something went wrong in MixedMedia component</p>}>
                        <MixedMedia stickyElementRef={mixMediaRef} floatElementRef={floatRef} />
                    </ErrorBoundary>
                    <OrderModule basedElementRef={orderModuleRef} />
                </div>
                <ErrorBoundary fallback={<p>Something went wrong variant panel</p>}>
                    <VariantPanel />
                </ErrorBoundary>
                <div className={styles.flexibleSetPage_bottom_container}>
                    <StickyHeader
                        onHeightChange={store.orderModuleStore.setStickHeaderHeight}
                        isEsApp={store.isEsApp}
                        variantButtonCount={variantButtonCount}
                        top={store.stickyHeaderTop}
                    >
                        <div>
                            <ArticleNumber isStickyHeader />
                            <div className={styles.to_top_button} onClick={scrollToTop} >
                                <div className={styles.button_label}>
                                    {helper.decodeHTML(store?.localization.generalL10n.changeSetComponents)}</div>
                                <IconArrowExtraSmallRight />
                            </div>
                        </div>
                        <div>
                            <ArticlePrice isStickyHeader />
                            <BasketPanel isStickyHeader />
                        </div>
                    </StickyHeader>
                    <ErrorBoundary fallback={<p>Product Info Shutter</p>}>
                        <ProductInfoShutter productInfoStore={store.productInfoStore} />
                        <ShutterModul
                            title={helper.decodeHTML(store.localization.generalL10n.additionalDescription)}
                            isOpen={true}
                            isMobileShop={store.isMobileShop}
                            notVisible={!hasLayoutedContentGrid}
                        >
                            <LayoutedContentGrid
                                debuggerIsOn={store.debuggerIsOn}
                                layoutedContentGridKeys={store?.fetchedData.shutterModule.layoutedContentGridKeys}
                                isRelease={store.dataStore.contextData.isRelease}
                                updateLayoutedContentGridState={updateLayoutedContentGridState}
                                colorCode={1} />
                        </ShutterModul>
                    </ErrorBoundary>
                </div>
            </div>
        );
    }));
export default FlexibleSetPage;
